
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import MyTabs from './children/views/Tabs/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  async fetch() {
    // 获取是否有过期的笔山数据
    await this.$store.$myV2.Account.BiShan.getExpireTime()
  },
  components: {
    MyTabs
  }
})
export default class MyPage extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.$store.$myV2.onReset()
  }
}
